import { Link } from "react-router";
import type { Language } from "../config/site";

export function NotFoundPage({ language }: { language: Language }) {
  return (
    <section className="not-found legal-width">
      <p className="eyebrow">404</p>
      <h1>{language === "tr" ? "Bu kasa bulunamadı." : "This vault could not be found."}</h1>
      <p>{language === "tr" ? "Bağlantı değişmiş veya sayfa taşınmış olabilir." : "The link may have changed or the page may have moved."}</p>
      <Link className="button button--primary" to={language === "tr" ? "/tr/" : "/"}>{language === "tr" ? "Ana sayfaya dön" : "Return home"}</Link>
    </section>
  );
}
